// An image has no timeline to trim on, so its list entry carries a fixed
// on-screen duration instead. Mirrors what AssetPreview stamps on an image it
// adds to a list.
export const IMAGE_ENTRY_IN_TIME = 0;
export const IMAGE_ENTRY_OUT_TIME = 5;
